import { LocalStorageKeys } from '@/constants'
import { IStore } from '@/store/types'
import { getLocalGlobalState, Storage } from '@/utils'
import { RouteRecordRaw } from 'vue-router'

export type AppState = {
  menus: RouteRecordRaw[]
  keepAliveComponents: string[]
}

export const state: AppState = getLocalGlobalState()?.app || {
  menus: [],
  keepAliveComponents: [],
}
